<template>
  <div>
    <el-dialog :visible.sync="modal1"        title="上传照片" width="1000px" center>
      <div class="cropper-content">
      <div class="cropper-box">
        <div class="cropper">
          <vue-cropper
              ref="cropper"
              :img="option.img"
              :outputSize="option.outputSize"
              :outputType="option.outputType"
              :info="option.info"
              :canScale="option.canScale"
              :autoCrop="option.autoCrop"
              :autoCropWidth="option.autoCropWidth"
              :autoCropHeight="option.autoCropHeight"
              :fixed="option.fixed"
              :fixedNumber="option.fixedNumber"
              :full="option.full"
              :fixedBox="option.fixedBox"
              :canMove="option.canMove"
              :canMoveBox="option.canMoveBox"
              :original="option.original"
              :centerBox="option.centerBox"
              :height="option.height"
              :infoTrue="option.infoTrue"
              :maxImgSize="option.maxImgSize"
              :enlarge="option.enlarge"
              :mode="option.mode"
              @realTime="realTime"
              @imgLoad="imgLoad">
          </vue-cropper>
        </div>
        <!--底部操作工具按钮-->
        <div class="footer-btn">
          <div class="scope-btn">
            <el-button size="mini" type="danger" plain icon="el-icon-zoom-in" @click="triggerUpload">选择照片</el-button>
            <el-button size="mini" type="danger" plain icon="el-icon-zoom-in" @click="changeScale(1)">放大</el-button>
            <el-button size="mini" type="danger" plain icon="el-icon-zoom-out" @click="changeScale(-1)">缩小</el-button>
            <el-button size="mini" type="danger" plain @click="rotateLeft">↺ 左旋转</el-button>
            <el-button size="mini" type="danger" plain @click="rotateRight">↻ 右旋转</el-button>
            <el-button size="mini" :loading="btnLoading" type="success" @click="uploadImg('blob')">上传<i class="el-icon-upload"></i></el-button>
          </div>
       
        </div>
      </div>
      <!--预览效果图-->
      <div class="show-preview">
        <div :style="previews.div" class="preview">
          <img :src="previews.url" :style="previews.img">
        </div>
      </div>
  </div>

    </el-dialog>
    <div class="dash-upload" :class="[size]">
    <el-upload
      class="picture-uploader"
      action=""
      ref="uploader"
      v-loading="loading"
      :accept="accept"
      :show-file-list="false"
      :http-request="uploadPicture"
      :before-upload="beforeUpload"
    >
      <img v-if="imgUrl" :src="imgUrl" class="picture" />
      <div v-if="!imgUrl">
        <i class="el-icon-plus"></i>
        <p>上传图片</p>
        <p>
          {{ tips || '支持分辨率不低于150k，1MB大小图片，支持PNG,JPG图片' }}
        </p>
      </div>
    </el-upload>
    <div class="utils" :class="[layout]" v-if="imgUrl">
      <div class="btn" @click="triggerUpload">重新上传</div>
      <div class="btn" @click="del">删除</div>
    </div>
  </div>

  </div>

</template>
<script>
import { VueCropper } from "vue-cropper";
import api from '@/api'
import axios from 'axios'
export default {
  name: 'dash-upload',
  data() {
    return {
      loading: false,
      imgUrl: '',
      fileType: '',
      modal1:false,
      btnLoading:false,
      name:this.Name,
      photoBase64:'',
      suffix:'',
      previews: {},
      headPhoto:{
        image:'',
        status:0
      },
      option: {
        img: '',             //裁剪图片的地址
        outputSize: 1,       //裁剪生成图片的质量(可选0.1 - 1)
        outputType: 'jpeg',  //裁剪生成图片的格式（jpeg || png || webp）
        info: true,          //图片大小信息
        canScale: true,      //图片是否允许滚轮缩放
        autoCrop: true,      //是否默认生成截图框
        autoCropWidth: 300,  //默认生成截图框宽度
        autoCropHeight: 400, //默认生成截图框高度
        fixed: true,         //是否开启截图框宽高固定比例
        fixedNumber: [3.55, 5], //截图框的宽高比例
        full: false,         //false按原比例裁切图片，不失真
        fixedBox: false,      //固定截图框大小，不允许改变
        canMove: true,      //上传图片是否可以移动
        canMoveBox: true,    //截图框能否拖动
        original: false,     //上传图片按照原始比例渲染
        centerBox: true,    //截图框是否被限制在图片里面
        height: true,        //是否按照设备的dpr 输出等比例图片
        infoTrue: false,     //true为展示真实输出图片宽高，false展示看到的截图框宽高
        maxImgSize: 3000,    //限制图片最大宽度和高度
        enlarge: 1,          //图片根据截图框输出比例倍数
        mode: '400px 300px'  //图片默认渲染方式
      },
    }
  },

  props: {
    // 上传文件的类型
    accept: {
      default: 'image/jpg,image/jpeg,image/png',
      type: String
    },
    // 功能文字位置： bottom / right
    layout: {
      type: String,
      default: 'bottom'
    },
    //尺寸： small / medium / large / square
    size: {
      type: String,
      default: 'small'
    },
    // 已上传文件路径
    mediaUrl: {
      type: String,
      default: ''
    },
    //上传图片类型
    typeString:{
      type:String,
      default:"C"     //C-会刊； P-展品
    },
    tips: {
      type: String,
      default: ''
    },
    // 展商注册上传图片不需要token
    needToken: {
      type: Boolean,
      default: false
    },
    // 是否需要验证人脸
    isFaceRead: {
      type: Boolean,
      default: false
    }
  },
  components: {
    VueCropper,
  },
  watch: {
    mediaUrl: function() {
      this.init()
    }
  },

  mounted() {
    this.fileType = this.accept
    this.init()
  },

  methods: {
    init() {
      this.imgUrl = this.mediaUrl
    },
    uploadAvatar(){

    },
    //初始化函数
    imgLoad (msg) {
      // console.log("工具初始化函数====="+msg)
    },
    //图片缩放
    changeScale (num) {
      num = num || 1
      this.$refs.cropper.changeScale(num)
    },
    //向左旋转
    rotateLeft () {
      this.$refs.cropper.rotateLeft()
    },
    //向右旋转
    rotateRight () {
      this.$refs.cropper.rotateRight()
    },
    //实时预览函数
    realTime (data) {
      this.previews = data
    },
        //上传图片
    uploadImg (type) {
      var that =this
      this.$refs.cropper.getCropData((data) => {
      
        that.btnLoading = true
        // var suffix = "";
        // var _ind = req.file.name.lastIndexOf(".");
        //     suffix = req.file.name.substr(_ind);
        if (this.isFaceRead) {
          let imgData = new FormData();
          imgData.append('UserName', 'qiuwenyan@eastfair.com');
          imgData.append('UserPwd', 'lkj13*ksjd$kjkj');
          imgData.append('ProjectType', 'Ezt');
          imgData.append('Project', 'fzz');
          imgData.append('PicType', 'avatar');
          imgData.append('ExhID', sessionStorage.getItem('ExhID'));
          imgData.append('Base64Img', data.split(',')[1]);
          //百度接口
          // let url = 'http://139.129.208.14/ai/api/Face/FaceDetect';
          let url = 'https://std.eastfair.com/Faceai/api/Face/FaceDetect';
          //test face
          axios({
            method: 'POST',
            url: url,
            cache: false,
            processData: false,
            contentType: false,
            data: imgData
          }).then(res => {
            if (res.data.status === 'OK') {
              // 上传图片
              const params = {
                suffix:that.suffix,
                type: this.typeString,
                base64: data.split(',')[1]
              }
              const apiUri = this.needToken? 'uploadimage1': 'uploadImg'
              api[apiUri](params).then(res => {
                if(res.data.code == '200'){
                  var _url = res.data.data.url
                  this.imgUrl = _url
                  this.$emit('update:mediaUrl', _url)
                  this.modal1 = false
                  that.btnLoading = false
                }else{
                  this.$message.error('图片上传失败')
                  that.btnLoading = false
                }
              }).finally(() => {
                this.loading = false
                that.btnLoading = false
              })
            } else {
              this.$message.error('请上传正确的人脸')
              that.btnLoading = false
            }
          })
        } else {
          // 上传图片
          const params = {
            suffix:suffix,
            type: this.typeString,
            base64: data.split(',')[1]
          }
          const apiUri = this.needToken? 'uploadimage1': 'uploadImg'
          api[apiUri](params).then(res => {
            if(res.data.code == '200'){
              var _url = res.data.data.url
              this.imgUrl = _url
              this.$emit('update:mediaUrl', _url)
            }else{
              this.$message.error('图片上传失败')
            }
          }).finally(() => {
            this.loading = false
            that.btnLoading = false
          })
        }


      });
    },
    uploadPicture(req) {
      const reader = new FileReader()
      reader.readAsDataURL(req.file)
      reader.onload = () => {
        var suffix = "";
        var _ind = req.file.name.lastIndexOf(".");
            suffix = req.file.name.substr(_ind);
        if (this.isFaceRead) {
          let imgData = new FormData();
          imgData.append('UserName', 'qiuwenyan@eastfair.com');
          imgData.append('UserPwd', 'lkj13*ksjd$kjkj');
          imgData.append('ProjectType', 'Ezt');
          imgData.append('Project', 'fzz');
          imgData.append('PicType', 'avatar');
          imgData.append('ExhID', sessionStorage.getItem('ExhID'));
          imgData.append('Base64Img', reader.result.split(',')[1]);
          //百度接口
          // let url = 'http://139.129.208.14/ai/api/Face/FaceDetect';
          let url = 'https://std.eastfair.com/Faceai/api/Face/FaceDetect';
          //test face
          axios({
            method: 'POST',
            url: url,
            cache: false,
            processData: false,
            contentType: false,
            data: imgData
          }).then(res => {
            if (res.data.status === 'OK') {
              // 上传图片
              const params = {
                suffix:suffix,
                type: this.typeString,
                base64: reader.result.split(',')[1]
              }
              const apiUri = this.needToken? 'uploadimage1': 'uploadImg'
              api[apiUri](params).then(res => {
                if(res.data.code == '200'){
                  var _url = res.data.data.url
                  this.imgUrl = _url
                  this.$emit('update:mediaUrl', _url)
                }else{
                  this.$message.error('图片上传失败')
                }
              }).finally(() => {
                this.loading = false
              })
            } else {
              this.$message.error('请上传正确的人脸')
              this.loading = false
            }
          })
        } else {
          // 上传图片
          const params = {
            suffix:suffix,
            type: this.typeString,
            base64: reader.result.split(',')[1]
          }
          const apiUri = this.needToken? 'uploadimage1': 'uploadImg'
          api[apiUri](params).then(res => {
            if(res.data.code == '200'){
              var _url = res.data.data.url
              this.imgUrl = _url
              this.$emit('update:mediaUrl', _url)
            }else{
              this.$message.error('图片上传失败')
            }
          }).finally(() => {
            this.loading = false
          })
        }
      }
    },

    beforeUpload(file) {

   
        var _ind = file.name.lastIndexOf(".");
            this.suffix = file.name.substr(_ind);

   


        // this.loading = true
        var status = true
        const isLt2M = file.size / 1024 / 1024 < 1
        // if (!isLt2M) {
        //   this.loading = false
        //   status = false
        //   this.$message.error('上传图片不能超过1MB')
        // }
        if ( file.type !='image/jpeg' &&  file.type !='image/png'&&  file.type !='image/jpg' ) {
          this.loading = false
          status = false
          this.$message.error('支持PNG,JPG格式')
          return status
        }

        this.fileType = file.name.replace(/.+\./,'')
        this.fileinfo = file;
        let data = window.URL.createObjectURL(new Blob([file]));
        this.option.img = data;
        this.modal1 = true
        // return status
        return false
    },

    triggerUpload() {
      this.$refs.uploader.$refs['upload-inner'].$refs['input'].click()
    },

    del() {
      this.imgUrl = ''
      this.$emit('update:mediaUrl', '')
    }
  }
}
</script>
<style lang="less">
// .dash-upload .picture{
//   width: auto !important;
// }
.cropper-content{
  display: flex;
  display: -webkit-flex;
  justify-content: flex-end;
}
.cropper-content .cropper-box{
  flex: 1;
  width: 100%;
}
.cropper-content .cropper-box .cropper{
  width: auto;
  height: 300px;
}
.cropper-content .show-preview{
  flex: 0 1 300px;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
}
.show-preview .preview{
  overflow: hidden;
  border:1px solid #67c23a;
  background: #cccccc;
}
.dash-upload {
  // width: 230px;
  padding-bottom: 10px;
  position: relative;
}
.dash-upload .picture-uploader .el-upload {
  border: 1px solid #DCDFE6;
  width: 100%;
  height: 100%;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  line-height: 2;
  font-size: 12px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #000;
  font-weight: 400;
}
.dash-upload .iconAdd {
  color: #000;
  width: 23px;
  height: 23px;
  font-size: 23px;
}
.dash-upload .picture-uploader .el-upload:hover {
  border-color: #f7f7f7;
}
.dash-upload.medium {
  width: 27vw;
}
.dash-upload.large {
  width: 70%;
}
.dash-upload.large-y {
  width: 460px;
}
.dash-upload.square {
  width: 230px;
}
.dash-upload.small .picture-uploader {
  // width: 100%;
  // max-height: 200px;
}
.dash-upload.large .picture-uploader {
  height: 22.778vw;
  width: 100%;
}
.dash-upload.large-y .picture-uploader {
  height: 640px;
  width: 100%;
}
.dash-upload.medium .picture-uploader,
.dash-upload.square .picture-uploader {
  height: 230px;
  width: 230px;
}
.dash-upload.square-small .picture-uploader {
  height: 180px;
  width: 180px;
}
.dash-upload.square-small-a {
  width: 206px;
}
.dash-upload .picture-uploader {
  // height: 100%;
  height: 206px;
  width: 100%;
}
.dash-upload .picture {
  width: 99%;
  height: 100%;
  display: block;
  object-fit: contain;
  max-height: 206px;
}
.dash-upload .utils {
  color: #f7f7f7;
  position: absolute;
  bottom: 12px;
  right: 2px;
  line-height: normal;
}
.dash-upload .utils.right {
  left: 102%;
  bottom: 40px;
  width: 100%;
}
.dash-upload .utils .btn {
  display: inline-block;
  margin-left: 12px;
  font-size: 14px;
  line-height: 1.5;
  cursor: pointer;
  font-weight: 400;
}
.dash-upload .utils .btn:hover {
  color:#f7f7f7;
}
.cropper{
  background: red;
  height:100px;
  width:100px
}
</style>
